<!-- components/Timeline.vue -->
<template>
  <div class="timeline">
    <div v-if="!incidents.length" class="text-gray-500 text-center py-4 ">
      No incidents recorded
    </div>
    <div v-else class="flow-root">
      <ul role="list">
        <li v-for="(incident, index) in sortedIncidents" :key="incident.id">
          <div class=" pb-8">
            <!-- Connect line between incidents -->
            <span v-if="index !== incidents.length - 1"
                  class=" left-4 top-4 h-full w-0.5 bg-gray-200"
                  aria-hidden="true">
            </span>
            <div class="relative flex space-x-3">
              <!-- Status Icon -->
              <div>
                <span class="h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white"
                      :class="getStatusClass(incident.status)">
                  <component :is="getStatusIcon(incident.status)"
                             class="h-5 w-5 text-white"
                             aria-hidden="true" />
                </span>
              </div>
              <!-- Incident Content -->
              <div class="flex min-w-0 flex-1 justify-between space-x-4 pt-1.5">
                <div>
                  <p class="text-sm text-gray-700">
                    {{ incident.description }}
                  </p>
                  <p class="mt-1 text-xs text-gray-500" v-if="incident.resolution">
                    Resolution: {{ incident.resolution }}
                  </p>
                </div>
                <div class="whitespace-nowrap text-right text-sm text-gray-500">
                  <time :datetime="incident.created_at">
                    {{ formatDate(incident.created_at) }}
                  </time>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import {
  ExclamationTriangleIcon,
  CheckCircleIcon,
  XCircleIcon
} from '@heroicons/vue/24/solid'

const props = defineProps({
  incidents: {
    type: Array,
    default: () => []
  }
})

const sortedIncidents = computed(() => {
  return [...props.incidents].sort((a, b) =>
      new Date(b.created_at) - new Date(a.created_at)
  )
})

const getStatusClass = (status) => {
  const classes = {
    breakdown: 'bg-red-500',
    resolved: 'bg-green-500',
    pending: 'bg-yellow-500',
    default: 'bg-gray-500'
  }
  return classes[status] || classes.default
}

const getStatusIcon = (status) => {
  const icons = {
    breakdown: ExclamationTriangleIcon,
    resolved: CheckCircleIcon,
    pending: XCircleIcon
  }
  return icons[status] || ExclamationTriangleIcon
}

const formatDate = (date) => {
  return new Date(date).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}
</script>